import productImage from './product-image.png'
function CallToAction() {
    return (
        <div id='cta-card' className="card bg-transparent w-100 rounded mx-auto text-light">
            <div id='cta-title' className="card-title rounded bg-transparent mx-auto fs-3 px-3 py-2 text-center">
               <b>Get a FREE $5 Amazon Gift Card when you purchase our Mobility Hip & Joint Soft Chews*:</b>
            </div>
            <div id='cta-subtitle' className="card-subtitle pb-1 fs-3 text-wrap text-center">
                <i>Your pet will love them - <br />so we made it a little easier to give them a try!</i>
            </div>
            <div id='cta-body' className="card-body">
                {/* <div id="list-parent" className="card-text fs-4"> */}
                <img src={productImage} className='row mx-auto py-3' />
                <div className='row'>
                    <ul id="card-list" className='d-flex flex-column justify-content-center fs-5 ps-5 mx-auto'>
                        <li className='mx-auto'>No shipping charges</li>
                        <li className='mx-auto'>No hidden fees</li>
                        <li className='mx-auto'>No credit card required!</li>
                    </ul>
                    </div>
                {/* </div> */}
            </div>
            <div className="card-footer bg-transparent rounded fs-6 w-80 mx-auto">
                <small>
                    <em>*Conditions Apply: Limited to one free Amazon Gift Card per household. <br />Offer valid only for customers that bought the product at full price <br />on our Official Seller Account on Amazon.com.</em>
                </small>
            </div>
            
        </div>
    );
}
export default CallToAction